import { PAYMENT_STATUS } from "../../components/reservation_v2/PaymentChip";
import { TicketStatusEnum } from "../../components/reservations/res.enum";

export interface IEsimStatusBadge {
  label: string;
  className: string;
}

// The purchase's status alone, worded and coloured as on the bus booking list.
export const esimStatusBadge = (status: number): IEsimStatusBadge => {
  const style = PAYMENT_STATUS[status];
  return style
    ? { label: style.name, className: style.className }
    : { label: "E panjohur", className: "bg-gray-500" };
};

export interface IEsimPaymentMethod {
  label: string;
  tip?: string;
}

const CARD_GATEWAYS: Record<number, string> = { 1: "RBKO", 2: "Stripe", 7: "NLB" };

// How the eSIM was paid, for a purchase that went through. The backend stores 0 both for a purchase
// paid entirely with Gjirafa Money and for a free eSIM (gift, reward, free with a bus ticket); the list
// cannot tell them apart. Null is an eSIM an admin created, always free.
export const esimPaymentMethod = (
  paymentMethodId: number | null | undefined,
  status: number
): IEsimPaymentMethod | null => {
  if (status === TicketStatusEnum.Pending || !PAYMENT_STATUS[status]) return null;
  if (paymentMethodId === null || paymentMethodId === undefined)
    return { label: "Falas", tip: "Krijuar nga admini" };
  if (paymentMethodId === 0)
    return { label: "Gjirafa Money ose falas", tip: "Pa pagesë me kartelë" };
  const gateway = CARD_GATEWAYS[paymentMethodId];
  return { label: gateway ? `Kartelë (${gateway})` : `Metoda ${paymentMethodId}` };
};
